import { render } from "./new_stack_p2_B.vue?vue&type=template&id=e10f6138&scoped=true"
import script from "./new_stack_p2_B.vue?vue&type=script&lang=js"
export * from "./new_stack_p2_B.vue?vue&type=script&lang=js"

import "./new_stack_p2_B.vue?vue&type=style&index=0&id=e10f6138&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e10f6138"]])

export default __exports__